import React, { useState } from 'react';
import { Button } from 'ui/atoms/Button';
import { Input } from 'ui/molecules/Input';
import styled, { css } from 'styled-components';
import { ChangePasswordFunctionProps } from 'ui/pages/Profile/Profile';
import { useTranslation } from 'react-i18next';

export type ChangePasswordProps = {
    changePassword: (data: ChangePasswordFunctionProps) => void;
    cancel: () => void;
};

const ChangePassword = ({ changePassword, cancel }: ChangePasswordProps): JSX.Element => {
    const { t } = useTranslation();
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newPasswordRepeat, setNewPasswordRepeat] = useState('');
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const handleOldPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setOldPassword(e.target.value);
    };

    const handleNewPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewPassword(e.target.value);
    };

    const handleNewPasswordRepeatChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewPasswordRepeat(e.target.value);
    };

    const checkIfPasswordsEqual = () => {
        if (newPassword !== newPasswordRepeat) {
            setError(true);
            setErrorMessage(t('profile.changePasswordErrorMessage'));
            return;
        }

        setError(false);
        setErrorMessage('');
    };

    const handleSubmitClick = () => {
        if (error) return;

        changePassword({ oldPassword, newPassword, newPasswordRepeat });
    };

    return (
        <div>
            <StyledInput
                name="oldPassword"
                type="password"
                label={t('profile.oldPassword')}
                value={oldPassword}
                onChange={handleOldPasswordChange}
            />
            <StyledInput
                name="newPassword"
                type="password"
                label={t('profile.newPassword')}
                value={newPassword}
                onChange={handleNewPasswordChange}
                onBlur={checkIfPasswordsEqual}
            />
            <StyledInput
                name="newPasswordRepeat"
                type="password"
                label={t('profile.newPasswordRepeat')}
                value={newPasswordRepeat}
                onChange={handleNewPasswordRepeatChange}
                onBlur={checkIfPasswordsEqual}
            />
            <ContainerBottom>
                <ContainerButton pos="left">
                    <Button text={t('navigation.cancel')} btnType="primary" onClick={cancel} />
                </ContainerButton>
                <ContainerButton pos="right">
                    <Button
                        disabled={error}
                        text={t('navigation.save')}
                        btnType="primary"
                        onClick={handleSubmitClick}
                    />
                </ContainerButton>
            </ContainerBottom>
            {error && <div>{errorMessage}</div>}
        </div>
    );
};

const StyledInput = styled(Input)`
    margin-bottom: 24px;
`;

const ContainerBottom = styled.div`
    display: flex;
`;

const ContainerButton = styled.div<{ pos: 'left' | 'right' }>`
    width: 100%;
    ${({ pos }) =>
        (pos === 'left' &&
            css`
                margin-right: 5px;
            `) ||
        (pos === 'right' &&
            css`
                margin-left: 5px;
            `)}
`;
export default ChangePassword;
